/**
 *
 * Redux Actions used to communicated to `<bp-data-store />`
 *
 * Presents an external interface for bp-connector implementations to hook
 * data sources to the bp-components.
 */
/**
 * On Request
 */
export const REQUEST = 'REQUEST';
export const onRequestAction = (payload) => ({
    type: REQUEST,
    payload,
});
export const onRequest = (payload) => (dispatch) => {
    dispatch(onRequestAction(payload));
};
/**
 * On Error
 */
export const ERROR = 'ERROR';
export const onErrorAction = (id, resolution, error, aggregationType) => ({
    type: ERROR,
    payload: {
        id,
        resolution,
        error,
        aggregationType,
    },
});
export const onError = (id, resolution, error, aggregationType) => (dispatch) => {
    dispatch(onErrorAction(id, resolution, error, aggregationType));
};
/**
 * On Success
 */
export const SUCCESS = 'SUCCESS';
export const onSuccessAction = (id, data, first, last, requestInformation) => ({
    type: SUCCESS,
    payload: {
        id,
        data,
        first,
        last,
        requestInformation,
    },
});
export const onSuccess = (id, data, first, last, requestInformation) => (dispatch) => {
    dispatch(onSuccessAction(id, data, first, last, requestInformation));
};
